/* Queries GraphQL para los combobox remotos (dominios, compañias, usuarios) */
import { gql } from "@apollo/client";

// Consulta dominios filtrada por tipo y padre (para dropdowns en cascada)
export const DOMAINSGENERAL = gql`
    query DOMAINSGENERAL(
      $search: String
      $first: Int
      $last: Int
      $type: String
      $parentid: String
    ) {
      domains(
        where: {
          name: { contains: $search }
          type: { equals: $type }
          parent_id: { equals: $parentid }
        }
        first: $first
        last: $last
        orderBy: { id: asc }
      ) {
        id
        name
      }
    }
  `;

// Compañias asignadas al usuario
export const COMPANIES = gql`
  query COMPANYBYUSER($user_id: String, $search: String, $first: Int, $last: Int, $company_id: String, $not: [String!]) {
    companiesByUser(
      user_id: $user_id
      search: $search
      first: $first
      last: $last
      company_id: $company_id
      not: {ids: $not}
    ) {
      id
      name
      product
    }
  }
`;

// Busqueda de usuarios para el combobox
export const GET_USER = gql`
  query UsersCombobox(
    $first: Int
    $last: Int
    $where: userWhereInput!
  ) {
    userss(
      where: $where
      first: $first
      last: $last
    ) {
       id
       nickname
       names
       lastnames
       email
       extras
       company {
         id
         name
       }
     }
  }
`